import {APIClient} from '../utils/APIClient';
import {isOk} from '../utils/apiResponse';
import {API_URL} from '../settings/local_settings';

// «Quién recibe esta alerta por mail» (tanda «Control de líneas», 15/10; contrato §4.3).
//
// `GET agency-client/<id>/alert-recipients/` (singular, como `active-alerts/`) → `{status: 'OK', data:
// {team: [{id, name, email, line_alerts?}], alerts: {<clave>: [user_id, …]}}}`. `team` es a quién le
// pueden llegar los mails de ese cliente (la misma regla que el envío; `line_alerts: false` = está sólo
// por la Economía) y cada clave de `alerts` —las 14 vienen siempre— dice quiénes tienen prendido ese
// aviso en «Mis alertas». Sin acceso contesta el 404 uniforme: el FE no deduce nada de él, sólo no dibuja.
//
// Prender o apagar el aviso propio es el MISMO interruptor de «Mis alertas»
// (`user/<id>/module/marketing/alerts/<slug>/<acción>`): no hay endpoint propio.
//
// ⚠️ `APIClient` no rechaza en 4xx: siempre hay que mirar `status === 'OK'`.
const RECIPIENTS_SEGMENT = 'alert-recipients/';

function recipientsUrl(clientId) {
    return `${API_URL}agency-client/${encodeURIComponent(clientId)}/${RECIPIENTS_SEGMENT}`;
}

function emailAlertUrl(userId, slug, active) {
    const action = active ? 'activate' : 'deactivate';
    return `${API_URL}user/${encodeURIComponent(userId)}/module/marketing/alerts/${slug}/${action}`;
}

/** `{team, alerts}` si la respuesta tiene la forma del contrato; `null` si no (BE viejo, 404, red). */
export function recipientsPayload(response) {
    if (!isOk(response)) return null;
    const payload = response.data || response.result;
    if (!payload || !Array.isArray(payload.team) || !payload.alerts || typeof payload.alerts !== 'object') {
        return null;
    }
    return {team: payload.team, alerts: payload.alerts};
}

export const AlertRecipientsApi = {
    // Las tarjetas de «Ahora» de un mismo cliente piden lo mismo: el cache de 30 s lo pide una vez.
    get(clientId) {
        return new APIClient(recipientsUrl(clientId)).call('GET', {}, {cache: true});
    },

    // Lo cambia quien mira (o, en «Mis alertas», el admin que edita a otro usuario). Si salió, el cache
    // de «quién recibe» queda viejo: se borra para que la próxima pantalla lo vea.
    setEmailAlert(userId, slug, active) {
        return new APIClient(emailAlertUrl(userId, slug, active)).call('POST').then((response) => {
            if (isOk(response)) APIClient.clearCache(RECIPIENTS_SEGMENT);
            return response;
        });
    },
};
